import React from 'react';

function SubscriptionExpiredModal({ isOpen, onClose, onGoToSubscription, subscriptionType }) {
  if (!isOpen) return null;

  const isTrial = subscriptionType === 'trial';

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-6 modal-text">
      <div className="bg-gradient-to-br from-[#1a1a2e] to-[#16213e] rounded-2xl p-8 max-w-md w-full shadow-2xl border border-white/10">
        <div className="text-center">
          {/* Icon */}
          <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center">
            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>

          {/* Title */}
          <h2 className="text-3xl font-bold mb-4">
            {isTrial ? 'Période d\'essai terminée' : 'Abonnement expiré'}
          </h2>

          {/* Message */}
          <p className="text-white/80 text-lg mb-8">
            {isTrial 
              ? 'Votre période d\'essai gratuite de 15 jours est terminée. Abonnez-vous pour continuer à profiter de votre musique sans interruption.'
              : 'Votre abonnement premium a expiré. Renouvelez-le pour continuer à écouter votre musique préférée.'
            }
          </p>

          {/* Benefits */}
          <div className="mb-8 text-left bg-white/5 rounded-lg p-4">
            <p className="font-semibold mb-3">Avec Premium, profitez de :</p>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span>Écoute sans publicité</span>
              </li>
              <li className="flex items-center gap-2">
                <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span>Téléchargement pour écoute hors ligne</span>
              </li>
              <li className="flex items-center gap-2">
                <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span>Qualité audio supérieure</span>
              </li>
              <li className="flex items-center gap-2">
                <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span>Écoute illimitée</span>
              </li>
            </ul>
          </div>

          {/* Buttons */}
          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="flex-1 py-3 bg-white/10 hover:bg-white/20 rounded-full font-semibold transition-colors"
            >
              Annuler
            </button>
            <button
              onClick={onGoToSubscription}
              className="flex-1 py-3 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 rounded-full font-bold transition-all shadow-lg hover:shadow-xl"
            >
              S'abonner maintenant
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionExpiredModal;
